import type { ActionMenuItemProps } from '@ekhodealer/ekho-common/rev';

// ============================================================================
// TABLE COLUMN ENUMS
// ============================================================================

/**
 * Enum for inventory table column IDs to ensure type safety and consistency
 */
export enum InventoryTableColumnId {
	CHECKBOX = 'checkbox',
	VEHICLE = 'vehicle',
	STATUS = 'status',
	VEHICLE_MATCH = 'vehicleMatch',
	SYNC_STATUS = 'syncStatus',
	LAST_SYNCED = 'lastSynced',
	PUBLISHED = 'published',
	MAKE = 'make',
	CATEGORY = 'category',
	YEAR = 'year',
	ODOMETER = 'odometer',
	COLOR = 'color',
	CONDITION = 'condition',
	ONLINE_SALES = 'onlineSales',
	INVENTORY_AGE = 'inventoryAge',
	FULFILLMENT_OPTIONS = 'fulfillmentOptions',
	MAP = 'map',
	ADVERTISED = 'advertised',
	RETAIL = 'retail',
	ACTIONS = 'actions',
	STOCK_NUMBER = 'stockNumber',
	VIN = 'vin',
	VIEWS_24HR = 'views24hr',
}

// ============================================================================
// ONLINE SALES ENUMS
// ============================================================================

/**
 * Online sales enum
 */
export enum OnlineSales {
	ENABLED = 'enabled',
	LEAD_GEN = 'lead-gen',
}

/**
 * Online sales options for dropdown components
 */
export const OnlineSalesOptions: ActionMenuItemProps[] = [
	{
		id: OnlineSales.ENABLED,
		label: 'Enabled',
		description: 'Buyers can complete the full purchase flow with Ekho Checkout.',
	},
	{
		id: OnlineSales.LEAD_GEN,
		label: 'Lead gen',
		description:
			'Capture leads online, but buyers must visit the showroom to complete purchase.',
	},
];

// ============================================================================
// MAP POLICY ENUMS
// ============================================================================

/**
 * MAP (Minimum Advertised Price) policy enum
 */
export enum MapPolicy {
	SUBJECT_TO_MAP = 'subject-to-map',
	NOT_SUBJECT_TO_MAP = 'not-subject-to-map',
}

/**
 * MAP policy options for dropdown components
 */
export const MapPolicyOptions: ActionMenuItemProps[] = [
	{
		id: MapPolicy.SUBJECT_TO_MAP,
		label: 'Yes, subject to a MAP policy',
	},
	{
		id: MapPolicy.NOT_SUBJECT_TO_MAP,
		label: 'No, not subject to a MAP policy',
	},
];
